import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';

import { IMyOptions } from 'mydatepicker';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TranslateService } from 'ng2-translate';

import { WorkConstants } from '../../work.const';

import { ProjectsService } from '../../services/projects.service';
import { AlertManagerService } from '../../../../shared/services/alert-manager.service';
import { InlineEditorService } from '../../../../shared/services/inline-editor.service';

import { TimeSheet } from '../../../models/time-sheet';
import { Constants } from '../../../../app.const';
declare var $: any;

@Component({
  selector: 'app-time-sheets',
  templateUrl: './time-sheets.component.html',
  styleUrls: ['./time-sheets.component.css'],
  providers: [DatePipe]
})

export class TimeSheetsComponent implements OnInit {
  timeSheet: FormGroup;
  @Input() sprintId: number;
  @Input() taskId: number;
  @Output() getSprint: EventEmitter<any> = new EventEmitter<any>();
  isEditTime: boolean = false;
  clickCount: number = 0;
  tabEvent: number;
  time: any = {};
  timeSheetObj: TimeSheet = new TimeSheet();
  isSubmitted: boolean = false;
  otherTimeSheet: any = [];
  workConstants: any = WorkConstants;
  timeLeft: number;

  // time sheet
  timePageId: number = 1;
  timePerPage: number = 1;
  timeCount: number = 1;
  timePageCount: number = 1;
  defaultTimePageId: number = 1;

  isDeleteConfirm: Array<boolean> = [];
  trasparent: boolean = false;
  private constants = Constants;
  private myDatePickerOptions: IMyOptions = {
    dateFormat: this.constants.dateFormatDatepicker,
    selectionTxtFontSize: '14px',
    editableDateField: false,
    disableUntil: { year: 2016, month: 8, day: 10 },
  };

  constructor(private formBuilder: FormBuilder,
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private translate: TranslateService,
    private inlineEditorService: InlineEditorService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.initTimesheet();
  }

  initTimesheet() {
    this.timeSheet = this.formBuilder.group({
      time_added: ['', Validators.required],
      date: ['', Validators.required],
      effort_time_left: [''],
      discription: ['', Validators.required]
    });
  }

  openModal(task, tabEvent?) {
    this.tabEvent = tabEvent;
    this.getTimeSheets(task.id, this.timePageId);
    this.timeLeft = task.effort_time_left;
    this.timeSheetObj.effort_time_left = this.timeLeft
  }

  openDeleteConfirmFrom(time) {
    this.trasparent = true;
    this.isDeleteConfirm[time.id] = true;
  }

  doConfirmeDelete(event, time) {
    if (event) {
      this.deleteTimeSheet(time);
    }
    this.trasparent = false;
    this.isDeleteConfirm[time.id] = false;
  }

  resetForm(): void {
    this.timeLeft = this.timeSheetObj.effort_time_left
    let emptyObject = {
      time_added: '',
      date: '',
      effort_time_left: this.timeLeft,
      discription: '',
    }
    this.timeSheet.setValue(emptyObject);
    this.isSubmitted = false;
    this.isEditTime = false;
  }

  updatedTimeLeft() {
    //let currentTimeLeft = 0;    
    if (this.timeSheetObj.time_added && this.timeSheetObj.time_added >= 0) {
      // check the addte time is >0 and round it in to two decimal
      this.timeSheetObj.time_added = this.timeSheetObj.time_added.replace(/[A-Za-z]/g, '');
      if (this.timeSheetObj.time_added.indexOf('.') !== -1) {
        var arrayVals = this.timeSheetObj.time_added.split('.');
        this.timeSheetObj.time_added = arrayVals[0] + "." + arrayVals[1].slice(0, 2);
        this.timeSheet.controls['time_added'].setValue(this.timeSheetObj.time_added);
        let currentTimeLeft = Math.round((this.timeLeft - this.timeSheetObj.time_added) * 100) / 100;
        this.timeSheet.controls['effort_time_left'].setValue(currentTimeLeft < 0 ? 0 : currentTimeLeft);
      }
    }
  }

  doCreateTimeSheets() {
    this.isSubmitted = true;
    if (this.timeSheet.valid) {
      this.saveChanges();
    }
  }

  saveChanges() {
    this.timeSheetObj.time_to_date = this.timeSheetObj.time_to_date.formatted;
    this.projectsService.updateTimeSheets(this.sprintId, this.taskId, this.timeSheetObj).subscribe(
      version => {
        this.resetForm();
        this.alertService.success({ title: "", msg: this.translate.instant("TIME_ADDED") });
        this.getTimeSheets(this.taskId, this.defaultTimePageId);
        this.getSprint.emit(this.tabEvent);
      }
    );
    this.resetForm();
  }

  getTimeSheets(taskId, timePageId) {
    let date = new Date();
    this.timeSheetObj.time_to_date = {
      date: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() },
      formatted: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    }
    this.projectsService.getTaskTimeSheet(taskId, this.sprintId, timePageId).subscribe(
      timeSheet => {
        this.otherTimeSheet = timeSheet.data.data;
        this.timePageId = parseInt(timeSheet.data.current_page)
        this.timeCount = timeSheet.data.total
        this.timePageCount = timeSheet.data.last_page
        this.timePerPage = timeSheet.data.per_page
        if (this.timePageId == this.timePageCount) {
          $('.pagination-next').hide();
        } else {
          $('.pagination-next').show();
        }
        this.scrollThePage();
      }, error => {

      }
    );
  }

  editTimeSheet(event, timeSheet: any, isTimeAdded: boolean) {
    if (event.value) {
      let dataObject = { taskId: this.taskId, sprintId: this.sprintId, timeSheet: timeSheet }
      var spendTime = isTimeAdded ? event.value : timeSheet.time_added
      // round the number to two digits
      spendTime = spendTime.replace(/[A-Za-z]/g, '');
      if (spendTime.indexOf('.') !== -1) {
        var arrayVals = spendTime.split('.');
        spendTime = arrayVals[0] + "." + arrayVals[1].slice(0, 2);
      }
      let body = {
        time_added: spendTime,
        time_to_date: timeSheet.time_to_date,
        description: !isTimeAdded ? event.value : timeSheet.description
      }
      
      this.projectsService.editTimeSheet(dataObject, body).subscribe(
        res => {
          this.timeSheetObj.effort_time_left = res.effortTimeLeft;
          this.getTimeSheets(this.taskId, this.timePageId);
          this.getSprint.emit(this.tabEvent);
          this.inlineEditorService.setValue(event);
          this.alertService.success({ title: "SUCCESS", msg: "Successfully Created" });
        },
        error => {
          event.value = isTimeAdded ? timeSheet.title : timeSheet.description;
          this.inlineEditorService.setValue(event);
        }
      );
    } else {
      this.alertService.error({ title: "ERROR", msg: "Description and spend time is Required" });
      event.value = isTimeAdded ? timeSheet.title : timeSheet.description;
      this.inlineEditorService.setValue(event);
    }
  }

  saveEditable(value) {
    //call to http service
  }
  setEditableData(time) {
    let setDob = this.datePipe.transform(time.time_to_date, 'dd/MM/yyyy');
    this.timeSheetObj.time_to_date = this.getDateObject(time.time_to_date);
    this.timeSheetObj.time_added = time.time_added;
    this.timeSheetObj.description = time.description;
    this.time = time;
    this.isEditTime = true;
  }

  dateConveter(timeSheetDate): boolean {
    let date = new Date();
    let currentDate = this.datePipe.transform(date, 'dd/MM/yyyy');
    let timeSheet = this.datePipe.transform(new Date(timeSheetDate.created_at), 'dd/MM/yyyy');
    if (currentDate == timeSheet) {
      return true;
    } else {
      return false;
    }
  }

  getDateObject(dateValue: string): any {
    let date = new Date(dateValue);
    return {
      date: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      },
      formatted: dateValue
    }
  }

  resetFields() {
    this.initTimesheet();
    this.isEditTime = false;
  }

  isTimeEditEnable() {
    this.isEditTime = false;
    this.initTimesheet();
  }

  deleteTimeSheet(time) {
    this.projectsService.deleteTaskTimes(time.id).subscribe(
      timeSheet => {
        this.getTimeSheets(this.taskId, this.timePageId);
        this.getSprint.emit(this.tabEvent);
      }, error => {

      }
    );
  }

  timePageChanged(event) {
    this.getTimeSheets(this.taskId, event);
  }

  /**
     * kauhslya
     * 2017-08-14
     * scroll The Page
     * @param event
  */
  scrollThePage() {
    window.scrollTo(0, 0);
  }

  /**
     * kauhslya
     * 2017-08-25
     * upadte the edding spend time for two decimals
     * @param event
  */
  updatingEditedTimeLeft(event) {
    var idAttr = event.target.id;
    var valueAttr = event.target.value;

    if (valueAttr && valueAttr >= 0) {
      // check the time is >0 and round it in to two decimal
      valueAttr = valueAttr.replace(/[A-Za-z]/g, '');
      if (valueAttr.indexOf('.') !== -1) {
        var arrayVals = valueAttr.split('.');
        valueAttr = arrayVals[0] + "." + arrayVals[1].slice(0, 2);
        $('#' + idAttr).val(valueAttr);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/time-sheet/time-sheets.component.ts